<template>
  <div class="panel">
    <div class="panel-heading">
      <h4 class="panel-title">成员</h4>
    </div>
    <div class="panel-body">
      <div class="row group-member">
        <div
          class="col-md-2 col-sm-4 col-xs-6"
          v-for="member in groupMembers"
          :key="member.group_member_number"
        >
          <div class="userlist">
            <div class="user-edit" v-show="hasPermission(member)">
              <div class="dropdown">
                <a
                  class="dropdown-toggle"
                  data-toggle="dropdown"
                  id="myTabDrop1"
                >
                  <i class="ti-settings" title="设置"></i>
                </a>
                <ul
                  aria-labelledby="myTabDrop1"
                  class="dropdown-menu dropdown-menu-right"
                  role="menu"
                >
                  <li v-show="moveSelfOutPermission(member)">
                    <a @click="quitFormGroup(member.group_member_number)"
                      >退出群组</a
                    >
                  </li>
                  <li v-show="moveOtherOutPermission(member)">
                    <a @click="removeFormGroup(member.group_member_number)"
                      >移出群组</a
                    >
                  </li>
                  <li v-show="right__groupMemberIdentity && transferPermission(member)">
                    <a
                      @click="
                        setIdentity(
                          member.group_member_number,
                          'owner',
                          member.group_member_identity
                        )
                      "
                      >转让给Ta</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="leader"
              data-placement="bottom"
              data-toggle="tooltip"
              :title="member.group_member_identity | identityNameFilter"
            >
              <svg aria-hidden="true" class="icon">
                <use
                  :xlink:href="member.group_member_identity | identityFilter"
                />
              </svg>
            </div>
            <router-link
              :to="{
                name: 'user',
                params: { userNumber: member.group_member_number },
              }"
              tag="div"
              class="user-avator"
              :style="member.group_member_avatar | avatarFilter"
            ></router-link>
            <div class="name">
              <h1>{{ member.group_member_name }}</h1>
              <p>{{ member.group_member_email || "无邮箱" }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const uavatar = require("@/assets/images/avator.svg");
import {
  getGroupMembers,
  groupMemberIdentity,
  groupMember,
} from "@/api/group/group";
export default {
  name: "GroupMember",
  data() {
    return {
      groupMembers: [],
    };
  },
  created() {
    this.groupNumber = this.$route.params.groupNumber;
  },
  computed: {
    right__groupMemberIdentity () {
      return this.$store.getters.right__groupMemberIdentity
    },
    groupInfo() {
      return this.$store.state.group.groupInfo;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    permissions() {
      return this.$store.state.group.permissions;
    },
    // 移除成员
    hasRemovePermission() {
      return (
        this.permissions.public_operations.indexOf("removeGroupMember") > -1
      );
    },
  },
  filters: {
    avatarFilter: function (value) {
      if (value.indexOf("http") > -1) {
        return "background-image: url(" + value + ");";
      } else {
        return "background-image: url(" + uavatar + ");";
      }
    },
    identityFilter: function (value) {
      let iden;
      switch (value) {
        case "owner":
          iden = "#icon-qunzhu";
          break;
        // case "admin":
        //   iden = "#icon-guanliyuan";
        //   break;
        default:
          break;
      }
      return iden;
    },
    identityNameFilter: function (value) {
      let iden;
      switch (value) {
        case "owner":
          iden = "群主";
          break;
        // case "admin":
        //   iden = "管理员";
        //   break;
        case "user":
          iden = "成员";
          break;
        default:
          break;
      }
      return iden;
    },
  },
  methods: {
    /**
     * 判断是否有转让权限
     * 1-仅群主可转让群
     * 2-只可转让给别人，不可转让给群主自己
     */
    transferPermission(member) {
      if (this.groupInfo.group_member_identity === "owner") {
        if (member.group_member_identity === "owner") {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    /**
     * 判断是否退出群权限
     * 1-除群主外其他人可自由退出群
     */
    moveSelfOutPermission(member) {
      if (this.groupInfo.group_member_identity === "owner") {
        return false;
      } else {
        return this.userInfo.user_number === member.group_member_number;
      }
    },
    /**
     * 判断是否有将他人移出群权限
     * 1-群主可移出除自己的所有人
     * 2-其他人如果有移出权限，可移出除自己和群主的其他人
     */
    moveOtherOutPermission(member) {
      if (this.groupInfo.group_member_identity === "owner") {
        if (this.userInfo.user_number === member.group_member_number) {
          return false;
        } else {
          return true;
        }
      } else if (member.group_member_identity === "owner") {
        return false;
      } else if (this.userInfo.user_number === member.group_member_number) {
        return false;
      } else {
        return this.hasRemovePermission;
      }
    },
    /**
     * 判断是否有操作权限
     */
    hasPermission(member) {
      return (
        this.moveOtherOutPermission(member) ||
        this.moveSelfOutPermission(member) ||
        this.transferPermission(member)
      );
    },
    // 退出群组
    quitFormGroup(user_number) {
      this.$confirm({
        type: "confirm",
        content: `确定退出群组？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          groupMember({
            group_number: this.groupNumber,
            action: "quit",
            members_list: [user_number],
          })
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$store
                  .dispatch("getGroupPublicInfo", this.groupNumber)
                  .then((res) => {
                    if (res.status_code === 200) {
                      this.getGroupMembers();
                    }
                  })
                  .catch((err) => {
                    this.$message({
                      type: "error",
                      message: err,
                    });
                  });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    // 移出群组
    removeFormGroup(user_number) {
      groupMember({
        group_number: this.groupNumber,
        action: "remove",
        members_list: [user_number],
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$message({
              type: "success",
              message: res.message,
            });
            this.getGroupMembers();
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 转让群（已没有设置群成员身份）
    setIdentity(user_number, identity, old_identity) {
      if (identity === "owner") {
        this.$confirm({
          type: "confirm",
          content: "确定转让吗？",
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
        })
          .then(() => {
            this.groupMemberIdentity(user_number, identity);
            return false;
          })
          .catch(() => {});
        return false;
      }
      if (identity === "admin" && old_identity === "admin") {
        identity = "user";
      }
      this.groupMemberIdentity(user_number, identity);
    },
    // 设置成员身份
    groupMemberIdentity(user_number, identity) {
      groupMemberIdentity({
        group_number: this.groupNumber,
        group_identity: identity,
        members_list: [user_number],
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$message({
              type: "success",
              message: res.message,
            });
            this.$store
              .dispatch("getGroupPublicInfo", this.groupNumber)
              .then((res) => {
                if (res.status_code === 200) {
                  this.getGroupMembers();
                }
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: err,
                });
              });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 获取群组成员
    getGroupMembers() {
      getGroupMembers({ group_number: this.groupNumber })
        .then((res) => {
          if (res.status_code === 200) {
            this.groupMembers = res.entity;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  mounted() {
    this.getGroupMembers();
  },
};
</script>

<style scoped>
</style>